import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MessagesComponent } from './messages.component';
import { StartMessageThreadComponent } from './start-message-thread/start-message-thread.component';

const routes: Routes = [
  { path: '', component: MessagesComponent },
  { path: 'new', component: StartMessageThreadComponent },
  { path: 'new/:template', component: StartMessageThreadComponent },
  { path: ':id', component: MessagesComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MessagesRoutingModule {}
